//import { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter, Row, Col } from "reactstrap"
import Swal from 'sweetalert2'
//import { UserContext } from '../context/UserProvider';
//import React, { useContext } from 'react';
import { Navigate } from "react-router-dom"
import DatePicker from "react-datepicker";



import { useState } from "react";
import React, { useContext } from 'react';
import { useEffect } from 'react';
import { UserContext } from '../context/UserProvider';
import { number } from "prop-types";

const modelo = {
    nombre: "",
    correo: "",
    idRolNavigation: {
        idRol: 0,
        descripcion: ""
    }
}

const modeloVenta = {

    idRegistro: 0,
    fechaVenta: "",
    rut: "",
    primerNombre: "",
    segundoNombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    telefono: "",
    correo: "",
    region: "",
    ciudad: "",
    domicilio: "",
    segmento: "",
    rubro: "",
    nombreEmpresa: "",
    tipoServicio: "",
    canalVenta: "",
    tipoEjecutivo: "",
    nombreEjecutivo: "",
    nombrePlan: "",
    numBeneficiarios: "",
    montoPlan: "",
    copago: "",
    valorCopago: "",
    rutPagador: "",
    primerPago:"",
    formaPago: "",
    frecuencia: "0",
    iva: "",
    empFacturacion: "",
    formaFacturacion: "",
    tipoVenta: "0",
    cantMesesPrepago: "0",
    descuento: "",
    formaVenta: "",
    idUsuario: "",
    montoPagar: ""
}

const FormVentas = () => {

    const { user } = useContext(UserContext);

    const [dataUser, setDataUser] = useState(modelo)


    useEffect(() => {
        let dt = JSON.parse(user)
        setDataUser(dt)

    }, [])

    const [venta, setVenta] = useState(modeloVenta);
    const [ventas, setVentas] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [planes, setPlanes] = useState([]);
    const [vendedores, setVendedores] = useState([]);


    const [disabledRubro, setDisabledRubro] = useState(true);
    const [rubros, setRubros] = useState([]);
    const [tipoServicio, setTipoServicio] = useState([]);
    const [primerPago, setPrimerPago] = useState([]);
    const [formaPago, setFormaPago] = useState([]);
    const [formaFacturacion, serFormaFacturacion] = useState([]);
    const [tipo, setTipo] = useState(""); // Estado para almacenar el tipo

    const [frecuencias, setFrecuencias] = useState([]);
    const [tipoVenta, setTipoVenta] = useState([]);
    const [disbleCantMeses, setDisbleCantMeses] = useState(true);
    const [disableFrecuencia, setDisableFrecuencia] = useState(true);

    const [mesesPrepago, setMesesPrepago] = useState([]);

    const [disableValorCopago, setDisableValorCopago] = useState(true);


    useEffect(() => {
        setRubros([{ value: "0", label: "Seleccionar" }]);
        setTipoServicio([{ value: "0", label: "Seleccionar" }]);
        setPrimerPago([{ value: "0", label: "Seleccionar" }]);
        setFormaPago([{ value: "0", label: "Seleccionar" }]);
        serFormaFacturacion([{ value: "0", label: "Seleccionar" }]);
        setPlanes([{ value: "0", label: "Seleccionar" }]);
        setDisabledRubro(true);
    }, []);

    let administrador;
    (dataUser.idRolNavigation.descripcion == "Administrador" || dataUser.idRolNavigation.descripcion == "Digitador") ? (administrador = true) : (administrador = false);

    const handleChange = (e) => {
        const { name, valor } = e.target;
       
        console.log(e.target.value)

        let value;

        value = e.target.value;

        setVenta({
            ...venta,
            [e.target.name]: value
        })

        if (name === "copago") {
            const debeBloquear = value === "NO" || value === "0";

            setVenta(prev => ({
                ...prev,
                copago: value,
                valorCopago: debeBloquear ? "" : prev.valorCopago
            }));

            // Opcional: también podrías agregar un estado que controle si se debe bloquear
            setDisableValorCopago(debeBloquear);
            return; // corta aquí para evitar doble setVenta si ya lo hiciste arriba
        }

        //setDisabledRubro(true); // Lo deshabilita si no hay selección válida

        if (name === "segmento")
        {
            let nuevoTipo = "";

            if (value === "PER_persona") {

                setFrecuencias([
                    { value: "0", label: "Seleccionar" },
                    { value: "Cada 1 mes", label: "Cada 1 mes" }
                ]);

                setTipoVenta([
                    { value: "0", label: "Seleccionar" },
                    { value: "Normal", label: "Normal" },
                    { value: "Prepago", label: "Prepago" }
                ]);

                setRubros([
                    { value: "0", label: "Seleccionar" },
                    { value: "persona", label: "Persona" }
                ]);

                setTipoServicio([
                    { value: "0", label: "Seleccionar" },
                    { value: "PFM_Plan_Familia", label: "PFM_Plan_Familia" }
                ]);

                setPrimerPago([
                    { value: "0", label: "Seleccionar" },
                    { value: "ONE CLICK", label: "ONE CLICK" },
                    { value: "TRANSFERENCIA", label: "TRANSFERENCIA" }
                ]);

                setFormaPago([
                    { value: "0", label: "Seleccionar" },
                    { value: "ONE CLICK", label: "ONE CLICK" },
                    { value: "TRANSFERENCIA", label: "TRANSFERENCIA" }
                ]);

                serFormaFacturacion([
                    { value: "0", label: "Seleccionar" },
                    { value: "Plan", label: "Plan" }
                ]);

                nuevoTipo = "PERSONA";

                setDisabledRubro(false); // Habilita el select

            } else if (value === "EMP_empresa") {

                setFrecuencias([
                    { value: "0", label: "Seleccionar" },
                    { value: "Cada 1 mes", label: "Cada 1 mes" },
                    { value: "Pago unico", label: "Pago unico" }
                ]);

                setTipoVenta([
                    { value: "0", label: "Seleccionar" },
                    { value: "Normal", label: "Normal" }
                ]);

                nuevoTipo = "EMPRESA";

                setRubros([
                    { value: "0", label: "Seleccionar" },
                    { value: "empresa", label: "Empresa" }
                ]);

                setTipoServicio([
                    { value: "0", label: "Seleccionar" },
                    { value: "CON_Convenio_Empresa", label: "CON_Convenio_Empresa" },
                    { value: "APR_Area_Protegida", label: "APR_Area_Protegida" },
                    { value: "ASE_Aseguradoras", label: "ASE_Aseguradoras" },
                    { value: "TEST_Test_Covid", label: "TEST_Test_Covid" },
                    { value: "TRS_Traslados", label: "TRS_Traslados" },
                    { value: "EVE_Evento_Protegido", label: "EVE_Evento_Protegido" }
                ]);

                setPrimerPago([
                    { value: "0", label: "Seleccionar" },
                    { value: "TRANSFERENCIA", label: "TRANSFERENCIA" },
                    { value: "DESCT PLANILLA", label: "DESCT PLANILLA" }
                ]);

                setFormaPago([
                    { value: "0", label: "Seleccionar" },
                    { value: "TRANSFERENCIA", label: "TRANSFERENCIA" },
                    { value: "DESCT PLANILLA", label: "DESCT PLANILLA" }
                ]);

                serFormaFacturacion([
                    { value: "0", label: "Seleccionar" },
                    { value: "Plan", label: "Plan" },
                    { value: "Abono Fijo", label: "Abono Fijo" }
                ]);

                setDisabledRubro(false); // Habilita el select

            } else {

                setRubros([
                    { value: "0", label: "Seleccionar" }
                ]);

                setTipoServicio([
                    { value: "0", label: "Seleccionar" }
                ]);

                setPrimerPago([
                    { value: "0", label: "Seleccionar" }
                ]);

                setFormaPago([
                    { value: "0", label: "Seleccionar" }
                ]);

                serFormaFacturacion([
                    { value: "0", label: "Seleccionar" }
                ]);

                nuevoTipo = "NINGUNO";

                setDisabledRubro(true); // Lo deshabilita si no hay selección válida
            }

            setTipo(nuevoTipo); // Actualizar estado de tipo
            obtenerPlanes(nuevoTipo);
        }

        if (name === "tipoVenta") {
            let opciones = [];
            let opcionesMeses = [];
            let nuevaVenta = { ...venta, [name]: value };

            if (value === "Normal") {

                if (venta.segmento === "PER_persona") {
                    setFrecuencias([
                        { value: "0", label: "Seleccionar" },
                        { value: "Cada 1 mes", label: "Cada 1 mes" }
                    ]);
                } else if (venta.segmento === "EMP_empresa") {
                    setFrecuencias([
                        { value: "0", label: "Seleccionar" },
                        { value: "Cada 1 mes", label: "Cada 1 mes" },
                        { value: "Pago unico", label: "Pago unico" }
                    ]);
                }

                //opciones = [
                //    "Cada 1 mes",
                //    "Pago unico"
                //];

                opcionesMeses = [
                    "0"
                ];

                nuevaVenta.cantMesesPrepago = "0";

                setDisbleCantMeses(true)
                setDisableFrecuencia(false)

            } else if (value === "Prepago") {

                opcionesMeses = [
                    "3",
                    "6",
                    "12"
                ];

                nuevaVenta.cantMesesPrepago = "0"; 
                nuevaVenta.frecuencia = "";      

                setDisableFrecuencia(true);
                setDisbleCantMeses(false)

            } else if (value === "0") {

                setDisableFrecuencia(true);
                setDisbleCantMeses(true)

            }

            setVenta(nuevaVenta);
            setMesesPrepago(opcionesMeses);
            //setFrecuencias(opciones);

        }

        if (name === "cantMesesPrepago") {
            let opciones = [];

            if (value === "3") {

                setFrecuencias([
                    { value: "0", label: "Seleccionar" },
                    { value: "Cada 3 meses", label: "Cada 3 meses" }
                ]);

            } else if (value === "6") {

                setFrecuencias([
                    { value: "0", label: "Seleccionar" },
                    { value: "Cada 6 meses", label: "Cada 6 meses" }
                ]);

            } else if (value === "12") {

                setFrecuencias([
                    { value: "0", label: "Seleccionar" },
                    { value: "Cada 12 meses", label: "Cada 12 meses" }
                ]);
            }

            setDisableFrecuencia(false);
            //setFrecuencias(opciones);

            // Asignar automáticamente el primer valor disponible como frecuencia
            setVenta(prev => ({
                ...prev,
                cantMesesPrepago: value,
                frecuencia: opciones[0] || ""
            }));
            
        }
    }

    const obtenerVentasPendientes = async () => {

        var usuario = JSON.parse(user).nombre;
        let response = await fetch("api/contrato/ListaVentasNuevas/" + usuario);

        if (response.ok) {
            let data = await response.json()
            setVentas(data)
            setPendiente(false)
        }
    }

    const obtenerPlanes = async (tipo) => {
        let response = await fetch("api/mantenedor/ListaPlanesForm/" + tipo);
        if (response.ok) {
            let data = await response.json()
            setPlanes(data)
        }
    }

    const obtenerVendedores = async () => {
        let response = await fetch("api/mantenedor/listarVendedoresFormVentas");
        if (response.ok) {
            let data = await response.json()
            setVendedores(data)
        }
    }

    useEffect(() => {
        obtenerVentasPendientes();
    }, [])

    const columns = [
        {
            name: 'Rut',
            selector: row => row.rut,
            sortable: true,
        },
        {
            name: 'Nombre',
            selector: row => row.primerNombre + " " + row.apellidoPaterno,
            sortable: true,
        },
        {
            name: 'Plan',
            selector: row => row.nombrePlan,
            sortable: true,
        },
        {
            name: 'Segmento',
            selector: row => row.segmento,
            sortable: true,
        },
        {
            name: 'Forma Pago',
            selector: row => row.formaPago,
            sortable: true,
        },
        {
            name: 'Monto Plan',
            selector: row => "$ " + row.montoPlan,
            sortable: true,
        },
        {
            name: 'Usuario',
            selector: row => row.nombreUsuario,
            sortable: true,
        },
        {
            name: 'Tipo',
            selector: row => row.formaVenta,
            sortable: true,
            cell: row => {
                let clase;
                clase = row.formaVenta ==  "Automática" ? "badge badge-info p-2" : "badge badge-danger p-2"
                return (
                    <span className={clase}>{row.formaVenta}</span>
                )
            }
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>

                    <Button color="danger" size="sm"
                        onClick={() => eliminarVenta(row.idRegistro)}
                    >
                        <i className="fas fa-trash-alt"></i>
                    </Button>

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const language = {
        emptyTable: "No hay información",
    }

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos'
    };

    const abrirModal = () => {
        obtenerPlanes("NINGUNO");
        obtenerVendedores();
        var fecha = new Date()
        setFechaInicio(fecha)
        setVenta(modeloVenta)
        setVerModal(!verModal);

        setDisbleCantMeses(true);
        setDisableFrecuencia(true);
        setMesesPrepago([]);
        setFrecuencias([]);
    }

    const abrirEditarModal = (data) => {

        if (data.segmento == "PER_persona") {
            setRubros([
                { value: "0", label: "Seleccionar" },
                { value: "persona", label: "Persona" }
            ]);

            setTipoServicio([
                { value: "0", label: "Seleccionar" },
                { value: "PFM_Plan_Familia", label: "PFM_Plan_Familia" }
            ]);

            setPrimerPago([
                { value: "0", label: "Seleccionar" },
                { value: "ONE CLICK", label: "ONE CLICK" },
                { value: "TRANSFERENCIA", label: "TRANSFERENCIA" }
            ]);

            setFormaPago([
                { value: "0", label: "Seleccionar" },
                { value: "ONE CLICK", label: "ONE CLICK" },
                { value: "TRANSFERENCIA", label: "TRANSFERENCIA" }
            ]);

            serFormaFacturacion([
                { value: "0", label: "Seleccionar" },
                { value: "Plan", label: "Plan" }
            ]);

            setVenta(data);
            obtenerPlanes("PERSONA");
            obtenerVendedores();
            var fecha = new Date(data.fechaVenta)
            setFechaInicio(fecha)
            setDisabledRubro(false);
            setVerModal(!verModal);
        }
        else
        {
            setRubros([
                { value: "0", label: "Seleccionar" },
                { value: "empresa", label: "Empresa" }
            ]);

            setTipoServicio([
                { value: "0", label: "Seleccionar" },
                { value: "CON_Convenio_Empresa", label: "CON_Convenio_Empresa" },
                { value: "APR_Area_Protegida", label: "APR_Area_Protegida" },
                { value: "ASE_Aseguradoras", label: "ASE_Aseguradoras" },
                { value: "TEST_Test_Covid", label: "TEST_Test_Covid" },
                { value: "TRS_Traslados", label: "TRS_Traslados" },
                { value: "EVE_Evento_Protegido", label: "EVE_Evento_Protegido" }
            ]);

            setPrimerPago([
                { value: "0", label: "Seleccionar" },
                { value: "TRANSFERENCIA", label: "TRANSFERENCIA" },
                { value: "DESCT PLANILLA", label: "DESCT PLANILLA" }
            ]);

            setFormaPago([
                { value: "0", label: "Seleccionar" },
                { value: "TRANSFERENCIA", label: "TRANSFERENCIA" },
                { value: "DESCT PLANILLA", label: "DESCT PLANILLA" }
            ]);

            serFormaFacturacion([
                { value: "0", label: "Seleccionar" },
                { value: "Plan", label: "Plan" },
                { value: "Abono Fijo", label: "Abono Fijo" }
            ]);

            setVenta(data);
            obtenerPlanes("EMPRESA");
            obtenerVendedores();
            var fecha = new Date(data.fechaVenta)
            setFechaInicio(fecha)
            setDisabledRubro(false);
            setVerModal(!verModal);
        }
        
    }

    const cerrarModal = () => {
        setVerModal(!verModal);
    }

    const error = {
        color: 'red',
        fontWeight: 'bold',
        fontSize: '14'
    }  

    var Fn = {
    validaRut: function(rutCompleto) {
        if (!/^[0-9]+-[0-9kK]{1}$/.test(rutCompleto))
            return false;
        var tmp = rutCompleto.split('-');
        var digv = tmp[1];
        var rut = tmp[0];
        if (digv == 'K') digv = 'k';
        return (Fn.dv(rut) == digv);
    },
        dv: function(T) {
            var M = 0,
                S = 1;
            for (; T; T = Math.floor(T / 10))
                S = (S + T % 10 * (9 - M++ % 6)) % 11;
            return S ? S - 1 : 'k';
        }
    }

    function validarEmail(valor) {
        if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(valor)) {
            return true
        } else {
            return false
        }
    }

    const guardarVenta = async () => {

        let response;
        venta.fechaVenta = fechaInicio;
        venta.idUsuario = dataUser.nombre;

        if (venta.idRegistro == 0) {
            

            if (venta.rut == "") {
                Swal.fire('Error!', 'Debe ingresar el RUT.', 'warning'); return;
            }
            if (venta.primerNombre == "") {
                Swal.fire('Error!', 'Debe ingresar el primer nombre.', 'warning'); return;
            }
            if (venta.apellidoPaterno == "") {
                Swal.fire('Error!', 'Debe ingresar el apellido paterno.', 'warning'); return;
            }
            if (venta.telefono == "") {
                Swal.fire('Error!', 'Debe ingresar el teléfono.', 'warning'); return;
            }
            if (venta.correo == "") {
                Swal.fire('Error!', 'Debe ingresar el correo.', 'warning'); return;
            }
            if (venta.region == 0) {
                Swal.fire('Error!', 'Debe seleccionar una región.', 'warning'); return;
            }
            if (venta.ciudad == 0) {
                Swal.fire('Error!', 'Debe seleccionar una ciudad.', 'warning'); return;
            }
            if (venta.domicilio == "") {
                Swal.fire('Error!', 'Debe ingresar el domicilio.', 'warning'); return;
            }
            if (venta.segmento == 0) {
                Swal.fire('Error!', 'Debe seleccionar un segmento.', 'warning'); return;
            }
            if (venta.rubro == 0) {
                Swal.fire('Error!', 'Debe seleccionar un rubro.', 'warning'); return;
            }
            if (venta.nombreEmpresa == 0) {
                Swal.fire('Error!', 'Debe seleccionar una empresa.', 'warning'); return;
            }
            if (venta.tipoServicio == 0) {
                Swal.fire('Error!', 'Debe seleccionar un tipo de servicio.', 'warning'); return;
            }
            if (venta.canalVenta == 0) {
                Swal.fire('Error!', 'Debe seleccionar un canal de venta.', 'warning'); return;
            }
            if (venta.tipoEjecutivo == 0) {
                Swal.fire('Error!', 'Debe seleccionar un tipo de ejecutivo.', 'warning'); return;
            }
            if (venta.nombreEjecutivo == 0) {
                Swal.fire('Error!', 'Debe seleccionar un nombre de ejecutivo.', 'warning'); return;
            }
            if (venta.nombrePlan == 0) {
                Swal.fire('Error!', 'Debe seleccionar un nombre de plan.', 'warning'); return;
            }
            if (venta.montoPlan == "") {
                Swal.fire('Error!', 'Debe ingresar el monto del plan.', 'warning'); return;
            }
            if (venta.copago == 0) {
                Swal.fire('Error!', 'Debe seleccionar si aplica copago.', 'warning'); return;
            }
            if (venta.rutPagador == "") {
                Swal.fire('Error!', 'Debe ingresar el RUT del pagador.', 'warning'); return;
            }
            if (venta.primerPago == 0) {
                Swal.fire('Error!', 'Debe seleccionar el primer pago.', 'warning'); return;
            }
            if (venta.formaPago == 0) {
                Swal.fire('Error!', 'Debe seleccionar la forma de pago.', 'warning'); return;
            }
            if (venta.iva == 0) {
                Swal.fire('Error!', 'Debe seleccionar el IVA.', 'warning'); return;
            }
            if (venta.empFacturacion == 0) {
                Swal.fire('Error!', 'Debe seleccionar la empresa de facturación.', 'warning'); return;
            }
            if (venta.formaFacturacion == 0) {
                Swal.fire('Error!', 'Debe seleccionar la forma de facturación.', 'warning'); return;
            }
            if (venta.tipoVenta == 0) {
                Swal.fire('Error!', 'Debe seleccionar el tipo de venta.', 'warning'); return;
            }
            if (venta.formaVenta == 0) {
                Swal.fire('Error!', 'Debe seleccionar la forma de venta.', 'warning'); return;
            }
            if (venta.montoPagar == 0) {
                Swal.fire('Error!', 'Debe ingresar el monto a pagar.', 'warning'); return;
            }
            if (venta.frecuencia == 0) {
                Swal.fire('Error!', 'Debe seleccionar la frecuencia.', 'warning'); return;
            }
                else {

                    if (!Fn.validaRut(venta.rut)) {
                        Swal.fire(
                            'Error!',
                            'Rut ingresado no es válido.',
                            'warning'
                        )
                    }
                    else if (!Fn.validaRut(venta.rutPagador)) {

                        Swal.fire(
                            'Error!',
                            'Rut pagador ingresado no es válido.',
                            'warning'
                        )
                    }
                else if (!validarEmail(venta.correo)) {
                    Swal.fire(
                        'Error!',
                        'Formato correo inválido.',
                        'warning'
                    )
                }
                else if (venta.copago == "SI" && venta.valorCopago == 0)
                {
                    Swal.fire(
                        'Error!',
                        'Es necesario agregar el valor del copago.',
                        'warning'
                    )
                }
                else if (venta.tipoVenta == "Prepago" && venta.cantMesesPrepago == 0) {
                    Swal.fire(
                        'Error!',
                        'Es necesario agregar la cantidad de meses prepago.',
                        'warning'
                    )
                }
                else if (venta.tipoVenta == "Prepago" && venta.descuento <= 0) {
                    Swal.fire(
                        'Error!',
                        'Es necesario agregar % de descuento.',
                        'warning'
                    )
                }
                else {

                    console.log(JSON.stringify(venta))
                    response = await fetch("api/contrato/GuardarVenta", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(venta)
                    })


                    if (response.ok) {

                        setVenta(modeloVenta)
                        setVerModal(!verModal);
                        obtenerVentasPendientes();

                        Swal.fire(
                            'Creada!',
                            'Venta Creada.',
                            'success'
                        )

                    } else {
                        Swal.fire(

                            'Error!',
                            'Error al crear venta ' + response,
                            'warning'
                        )
                    }
                }
            }
        }
        else {

            if (venta.rut == "") {
                Swal.fire('Error!', 'Debe ingresar el RUT.', 'warning'); return;
            }
            if (venta.primerNombre == "") {
                Swal.fire('Error!', 'Debe ingresar el primer nombre.', 'warning'); return;
            }
            if (venta.apellidoPaterno == "") {
                Swal.fire('Error!', 'Debe ingresar el apellido paterno.', 'warning'); return;
            }
            if (venta.telefono == "") {
                Swal.fire('Error!', 'Debe ingresar el teléfono.', 'warning'); return;
            }
            if (venta.correo == "") {
                Swal.fire('Error!', 'Debe ingresar el correo.', 'warning'); return;
            }
            if (venta.region == 0) {
                Swal.fire('Error!', 'Debe seleccionar una región.', 'warning'); return;
            }
            if (venta.ciudad == 0) {
                Swal.fire('Error!', 'Debe seleccionar una ciudad.', 'warning'); return;
            }
            if (venta.domicilio == "") {
                Swal.fire('Error!', 'Debe ingresar el domicilio.', 'warning'); return;
            }
            if (venta.segmento == 0) {
                Swal.fire('Error!', 'Debe seleccionar un segmento.', 'warning'); return;
            }
            if (venta.rubro == 0) {
                Swal.fire('Error!', 'Debe seleccionar un rubro.', 'warning'); return;
            }
            if (venta.nombreEmpresa == 0) {
                Swal.fire('Error!', 'Debe seleccionar una empresa.', 'warning'); return;
            }
            if (venta.tipoServicio == 0) {
                Swal.fire('Error!', 'Debe seleccionar un tipo de servicio.', 'warning'); return;
            }
            if (venta.canalVenta == 0) {
                Swal.fire('Error!', 'Debe seleccionar un canal de venta.', 'warning'); return;
            }
            if (venta.tipoEjecutivo == 0) {
                Swal.fire('Error!', 'Debe seleccionar un tipo de ejecutivo.', 'warning'); return;
            }
            if (venta.nombreEjecutivo == 0) {
                Swal.fire('Error!', 'Debe seleccionar un nombre de ejecutivo.', 'warning'); return;
            }
            if (venta.nombrePlan == 0) {
                Swal.fire('Error!', 'Debe seleccionar un nombre de plan.', 'warning'); return;
            }
            if (venta.montoPlan == "") {
                Swal.fire('Error!', 'Debe ingresar el monto del plan.', 'warning'); return;
            }
            if (venta.copago == 0) {
                Swal.fire('Error!', 'Debe seleccionar si aplica copago.', 'warning'); return;
            }
            if (venta.rutPagador == "") {
                Swal.fire('Error!', 'Debe ingresar el RUT del pagador.', 'warning'); return;
            }
            if (venta.primerPago == 0) {
                Swal.fire('Error!', 'Debe seleccionar el primer pago.', 'warning'); return;
            }
            if (venta.formaPago == 0) {
                Swal.fire('Error!', 'Debe seleccionar la forma de pago.', 'warning'); return;
            }
            if (venta.iva == 0) {
                Swal.fire('Error!', 'Debe seleccionar el IVA.', 'warning'); return;
            }
            if (venta.empFacturacion == 0) {
                Swal.fire('Error!', 'Debe seleccionar la empresa de facturación.', 'warning'); return;
            }
            if (venta.formaFacturacion == 0) {
                Swal.fire('Error!', 'Debe seleccionar la forma de facturación.', 'warning'); return;
            }
            if (venta.tipoVenta == 0) {
                Swal.fire('Error!', 'Debe seleccionar el tipo de venta.', 'warning'); return;
            }
            if (venta.formaVenta == 0) {
                Swal.fire('Error!', 'Debe seleccionar la forma de venta.', 'warning'); return;
            }
            if (venta.montoPagar == 0) {
                Swal.fire('Error!', 'Debe ingresar el monto a pagar.', 'warning'); return;
            }
            if (venta.frecuencia == 0) {
                Swal.fire('Error!', 'Debe seleccionar la frecuencia.', 'warning'); return;
            }
            else {

                if (!Fn.validaRut(venta.rut)) {
                    Swal.fire(
                        'Error!',
                        'Rut ingresado no es válido.',
                        'warning'
                    )
                }
                else if (!Fn.validaRut(venta.rutPagador)) {

                    Swal.fire(
                        'Error!',
                        'Rut pagador ingresado no es válido.',
                        'warning'
                    )
                }
                else if (!validarEmail(venta.correo)) {
                    Swal.fire(
                        'Error!',
                        'Formato correo inválido.',
                        'warning'
                    )
                }
                else if (venta.copago == "SI" && venta.valorCopago == 0) {
                    Swal.fire(
                        'Error!',
                        'Es necesario agregar el valor del copago.',
                        'warning'
                    )
                }
                else if (venta.tipoVenta == "Prepago" && venta.cantMesesPrepago == 0) {
                    Swal.fire(
                        'Error!',
                        'Es necesario agregar la cantidad de meses prepago.',
                        'warning'
                    )
                }
                else {
                    response = await fetch("api/contrato/ActualizarVenta", {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(venta)
                    })


                    if (response.ok) {

                        setVenta(modeloVenta)
                        setVerModal(!verModal);
                        obtenerVentasPendientes();

                        Swal.fire(
                            'Actualizada!',
                            'Venta Actualizada.',
                            'success'
                        )

                    } else {

                        Swal.fire(
                            'Error!',
                            'Error al actualizar venta',
                            'warning'
                        )
                    }
                }
            }
        }

        

        
    }

    const eliminarVenta = async (idRegistro) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar la venta",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.isConfirmed) {

                const response = fetch("api/contrato/eliminarVenta/" + idRegistro, { method: "POST" })
                    .then(response => {
                        if (response.ok) {

                            obtenerVentasPendientes();

                            Swal.fire(
                                'Eliminado!',
                                'La venta fue eliminada.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    if (!administrador && dataUser.idRolNavigation.descripcion != "") {
        //return <Redirect to="/clientes" />
        return <Navigate to="/" />
        //this.props.history.push('/clientes');
    }

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Ventas Nuevas
                </CardHeader>
                <CardBody>
                    <Button color="success" size="sm" onClick={abrirModal}>Nueva Venta</Button>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={ventas}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                        noDataComponent="No se encontraron resultados" //or your component
                    />
                </CardBody>
            </Card>

            <Modal size="xl" isOpen={verModal}>
                <ModalHeader>
                    Ingreso Venta
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm={2}>
                            <Label style={{ fontSize: "12px" }} className="font-weight-bold">Fecha Venta :</Label>
                            <DatePicker
                                className="form-control form-control-sm"
                                selected={fechaInicio}
                                onChange={(date) => setFechaInicio(date)}
                                dateFormat='dd/MM/yyyy'
                            />
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Rut :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" name="rut" onChange={handleChange} value={venta.rut} id="rut" />
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Primer Nombre :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" name="primerNombre" onChange={handleChange} value={venta.primerNombre} />
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Segundo Nombre :</Label>
                                <Input bsSize="sm" name="segundoNombre" onChange={handleChange} value={venta.segundoNombre} />
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Apellido Paterno :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" name="apellidoPaterno" onChange={handleChange} value={venta.apellidoPaterno} />
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Apellido Materno :</Label>
                                <Input bsSize="sm" name="apellidoMaterno" onChange={handleChange} value={venta.apellidoMaterno} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Teléfono :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" name="telefono" onChange={handleChange} value={venta.telefono} />
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Correo :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" name="correo" onChange={handleChange} value={venta.correo} />
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Región :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="region" onChange={handleChange} value={venta.region}>
                                    <option value={0}>Seleccionar</option>
                                    <option value={"Región de Antofagasta"}>Región de Antofagasta</option>
                                    <option value={"Región de Atacama"}>Región de Atacama</option>
                                    <option value={"Región de Coquimbo"}>Región de Coquimbo</option>
                                    <option value={"Región Metropolitana"}>Región Metropolitana</option>
                                    <option value={"Región de Valparaíso"}>Región de Valparaíso</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Ciudad :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="ciudad" onChange={handleChange} value={venta.ciudad}>
                                    <option value={0}>Seleccionar</option>
                                    <option value={"Iquique"}>Iquique</option>
                                    <option value={"Antofagasta"}>Antofagasta</option>
                                    <option value={"Calama"}>Calama</option>
                                    <option value={"Copiapo"}>Copiapo</option>
                                    <option value={"Coquimbo"}>Coquimbo</option>
                                    <option value={"La Serena"}>La Serena</option>
                                    <option value={"Santiago"}>Santiago</option>
                                    <option value={"Viña del mar"}>Viña del mar</option>
                                    <option value={"Quilpue"}>Quilpue</option>
                                    
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={4}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Domicilio :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" name="domicilio" onChange={handleChange} value={venta.domicilio} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Segmento :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="segmento" onChange={handleChange} value={venta.segmento}>
                                    <option value={0}>Seleccionar</option>
                                    <option value={"PER_persona"}>PER_persona</option>
                                    <option value={"EMP_empresa"}>EMP_empresa</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Rubro :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="rubro" onChange={handleChange} value={venta.rubro} disabled={disabledRubro}>
                                    {rubros.map((rubro) => (
                                        <option key={rubro.value} value={rubro.value}>
                                            {rubro.label}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={4}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Nombre Empresa :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="nombreEmpresa" onChange={handleChange} value={venta.nombreEmpresa} disabled={disabledRubro}>
                                    <option value={0}>Seleccionar</option>
                                    {
                                        planes.map((item) => (<option key={item.idPlan} value={item.nombrePlan}>{item.nombrePlan}</option>))
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Tipo Servicio :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="tipoServicio" onChange={handleChange} value={venta.tipoServicio} disabled={disabledRubro}>
                                    {tipoServicio.map((tipoServicio) => (
                                        <option key={tipoServicio.value} value={tipoServicio.value}>
                                            {tipoServicio.label}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Canal Venta :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="canalVenta" onChange={handleChange} value={venta.canalVenta}>
                                    <option value={0}>Seleccionar</option>
                                    <option value={"REMOTA"}>REMOTA</option>
                                    <option value={"PRESENCIAL"}>PRESENCIAL</option>
                                    <option value={"AUTOWEB"}>AUTOWEB</option>
                                    <option value={"GERENCIA"}>GERENCIA</option>
                                    <option value={"DEALER"}>DEALER</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Tipo Ejecutivo :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="tipoEjecutivo" onChange={handleChange} value={venta.tipoEjecutivo}>
                                    <option value={0}>Seleccionar</option>
                                    <option value={"AUTOWEB"}>AUTOWEB</option>
                                    <option value={"FREELANCE"}>FREELANCE</option>
                                    <option value={"VTA.INTERNA"}>VTA.INTERNA</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Nombre Ejecutivo :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="nombreEjecutivo" onChange={handleChange} value={venta.nombreEjecutivo} >
                                    <option value={0}>Seleccionar</option>
                                    {
                                        vendedores.map((item) => (<option key={item.nombreVendedor} value={item.nombreVendedor}>{item.nombreVendedor}</option>))
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={4}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Nombre Plan :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="nombrePlan" onChange={handleChange} value={venta.nombrePlan} disabled={disabledRubro}>
                                    <option value={0}>Seleccionar</option>
                                    {
                                        planes.map((item) => (<option key={item.idPlan} value={item.nombrePlan}>{item.nombrePlan}</option>))
                                    }
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Num Beneficiarios :</Label>
                                {/*<Input type="number" style={{ fontSize: "12px" }} name="numBeneficiarios" onChange={handleChange} value={venta.numBeneficiarios} />*/}
                                <Input bsSize="sm" type={"select"} name="numBeneficiarios" onChange={handleChange} value={venta.numBeneficiarios}>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>
                                    <option value={7}>7</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Monto Plan :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input type="number" style={{ fontSize: "12px" }} name="montoPlan" onChange={handleChange} value={venta.montoPlan} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Copago :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="copago" onChange={handleChange} value={venta.copago}>
                                    <option value={0}>Seleccionar</option>
                                    <option value={"SI"}>SI</option>
                                    <option value={"NO"}>NO</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Valor Copago :</Label>
                                <Input type="number" style={{ fontSize: "12px" }} name="valorCopago" onChange={handleChange} value={venta.valorCopago} disabled={disableValorCopago} />
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Rut Pagador:</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" name="rutPagador" onChange={handleChange} value={venta.rutPagador} />
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Primer Pago :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="primerPago" onChange={handleChange} value={venta.primerPago} disabled={disabledRubro}>
                                    {primerPago.map((pago) => (
                                        <option key={pago.value} value={pago.value}>
                                            {pago.label}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Forma Pago :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="formaPago" onChange={handleChange} value={venta.formaPago} disabled={disabledRubro}>
                                    {formaPago.map((pago) => (
                                        <option key={pago.value} value={pago.value}>
                                            {pago.label}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">% Descuento :</Label>
                                <Input type="number" style={{ fontSize: "12px" }} name="descuento" onChange={handleChange} value={venta.descuento} />
                            </FormGroup>
                        </Col>
                        {/*<Col sm={2}>*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label style={{ fontSize: "12px" }} className="font-weight-bold">Frecuencia :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>*/}
                        {/*        <Input bsSize="sm" type={"select"} name="frecuencia" onChange={handleChange} value={venta.frecuencia}>*/}
                        {/*            <option value={0}>Seleccionar</option>*/}
                        {/*            <option value={'Cada 1 mes'}>Cada 1 mes</option>*/}
                        {/*            <option value={'Cada 2 meses'}>Cada 2 meses</option>*/}
                        {/*            <option value={'Cada 3 meses'}>Cada 3 meses</option>*/}
                        {/*            <option value={'Cada 4 meses'}>Cada 4 meses</option>*/}
                        {/*            <option value={'Cada 5 meses'}>Cada 5 meses</option>*/}
                        {/*            <option value={'Cada 6 meses'}>Cada 6 meses</option>*/}
                        {/*            <option value={'Cada 7 meses'}>Cada 7 meses</option>*/}
                        {/*            <option value={'Cada 8 meses'}>Cada 8 meses</option>*/}
                        {/*            <option value={'Cada 9 meses'}>Cada 9 meses</option>*/}
                        {/*            <option value={'Cada 10 meses'}>Cada 10 meses</option>*/}
                        {/*            <option value={'Cada 11 meses'}>Cada 11 meses</option>*/}
                        {/*            <option value={'Cada 12 meses'}>Cada 12 meses</option>*/}
                        {/*            <option value={'Pago unico'}>Pago unico</option>*/}

                        {/*        </Input>*/}
                        {/*    </FormGroup>*/}
                        {/*</Col>*/}
                    </Row>
                    <Row>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Iva :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="iva" onChange={handleChange} value={venta.iva}>
                                    <option value={0}>Seleccionar</option>
                                    {/*<option value={"Afecto"}>Afecto</option>*/}
                                    <option value={"Exento"}>Exento</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Emp Facturación :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="empFacturacion" onChange={handleChange} value={venta.empFacturacion}>
                                    <option value={0}>Seleccionar</option>
                                    <option value={"RST"}>RST</option>
                                    {/*<option value={"Copayapu"}>Copayapu</option>*/}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Forma Facturación :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="formaFacturacion" onChange={handleChange} value={venta.formaFacturacion} disabled={disabledRubro}>
                                    {formaFacturacion.map((facturacion) => (
                                        <option key={facturacion.value} value={facturacion.value}>
                                            {facturacion.label}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Tipo Venta :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="tipoVenta" onChange={handleChange} value={venta.tipoVenta}>
                                    {/*<option value={0}>Seleccionar</option>*/}
                                    {/*<option value={"Normal"}>Normal</option>*/}
                                    {/*<option value={"Prepago"}>Prepago</option>*/}
                                    {tipoVenta.map((tipoVenta) => (
                                        <option key={tipoVenta.value} value={tipoVenta.value}>
                                            {tipoVenta.label}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Cant. Meses Prepago :</Label>
                                {/*<Input type="number" style={{ fontSize: "12px" }} name="cantMesesPrepago" onChange={handleChange} value={venta.cantMesesPrepago} />*/}
                                <Input bsSize="sm" type={"select"} name="cantMesesPrepago" onChange={handleChange} value={venta.cantMesesPrepago} disabled={disbleCantMeses }>
                                    {/*<option value={0}>0</option>*/}
                                    {/*<option value={3}>3</option>*/}
                                    {/*<option value={6}>6</option>*/}
                                    {/*<option value={12}>12</option>*/}
                                    <option value={0}>Seleccionar</option>
                                    {mesesPrepago.map((f, index) => (
                                        <option key={index} value={f}>{f}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        {/*<Col sm={2}>*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label style={{ fontSize: "12px" }} className="font-weight-bold">% Descuento :</Label>*/}
                        {/*        <Input type="number" style={{ fontSize: "12px" }} name="descuento" onChange={handleChange} value={venta.descuento} />*/}
                        {/*    </FormGroup>*/}
                        {/*</Col>*/}
                        {/*<Col sm={2}>*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label style={{ fontSize: "12px" }} className="font-weight-bold">Frecuencia :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>*/}
                        {/*        <Input bsSize="sm" type={"select"} name="frecuencia" onChange={handleChange} value={venta.frecuencia}>*/}
                        {/*            <option value={0}>Seleccionar</option>*/}
                        {/*            <option value={'Cada 1 mes'}>Cada 1 mes</option>*/}
                        {/*            <option value={'Cada 2 meses'}>Cada 2 meses</option>*/}
                        {/*            <option value={'Cada 3 meses'}>Cada 3 meses</option>*/}
                        {/*            <option value={'Cada 4 meses'}>Cada 4 meses</option>*/}
                        {/*            <option value={'Cada 5 meses'}>Cada 5 meses</option>*/}
                        {/*            <option value={'Cada 6 meses'}>Cada 6 meses</option>*/}
                        {/*            <option value={'Cada 7 meses'}>Cada 7 meses</option>*/}
                        {/*            <option value={'Cada 8 meses'}>Cada 8 meses</option>*/}
                        {/*            <option value={'Cada 9 meses'}>Cada 9 meses</option>*/}
                        {/*            <option value={'Cada 10 meses'}>Cada 10 meses</option>*/}
                        {/*            <option value={'Cada 11 meses'}>Cada 11 meses</option>*/}
                        {/*            <option value={'Cada 12 meses'}>Cada 12 meses</option>*/}
                        {/*            <option value={'Pago unico'}>Pago unico</option>*/}

                        {/*        </Input>*/}
                        {/*    </FormGroup>*/}
                        {/*</Col>*/}
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Frecuencia :</Label>
                                <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type="select" name="frecuencia" onChange={handleChange} value={venta.frecuencia} disabled={disableFrecuencia}>
                                    {/*<option value={0}>Seleccionar</option>*/}
                                    {frecuencias.map((frecuencias) => (
                                        <option key={frecuencias.value} value={frecuencias.value}>
                                            {frecuencias.label}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Monto a Pagar :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input type="number" style={{ fontSize: "12px" }} name="montoPagar" onChange={handleChange} value={venta.montoPagar} />
                            </FormGroup>
                        </Col>
                        <Col sm={2}>
                            <FormGroup>
                                <Label style={{ fontSize: "12px" }} className="font-weight-bold">Forma Venta :</Label> <Label style={{ fontSize: "12px", color: "red" }} className="font-weight-bold">*</Label>
                                <Input bsSize="sm" type={"select"} name="formaVenta" onChange={handleChange} value={venta.formaVenta}>
                                    <option value={0}>Seleccionar</option>
                                    <option value={"Automática"}>Automática</option>
                                    <option value={"Manual"}>Manual</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary" onClick={guardarVenta}>Guardar Venta</Button>
                    <Button size="sm" color="danger" onClick={cerrarModal}>Cerrar</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default FormVentas;